import ValueExpression from '@legacy-modules/valueexpressions/models/valueexpressions/ValueExpression';
import { PositiveDirection } from '@legacy-modules/metrics2/models/entities/PositiveDirection';
import { getDefinitionByName } from '@legacy-modules/common/util/kpiDefinitions';

export default new ValueExpression({
  identifier: 'lma-anomalies.uv.distanceviolation.DV100kmRL.count',
  label: 'Distanzverstoß ohne Zustellversuch',
  definition: getDefinitionByName('Distanzverstoß ohne Zustellversuch'),
  positiveDirection: PositiveDirection.custom,
});
